import { ApolloClient } from "@apollo/client";
import React from "react";
import HomeHero from "../../components/HomeHero/HomeHero";
import Layout from "../../components/Layout/Layout";
import Sidebar from "../../components/Sidebar/Sidebar";
import { HomeHeader } from "../../components/SiteHeader/SiteHeader";
import { sidebarDataQueries, useSidebarQuery } from "./SidebarQuery";

export default function HomeLayout(props: {
  children: React.ReactNode;
  hideSidebar?: boolean;
  metaDescription: string;
  metaTitle: string;
  metaUrl: string;
}) {
  const { data } = useSidebarQuery();

  const filterBarRef = React.useRef<HTMLDivElement>(null);

  return (
    <Layout
      metaDescription={props.metaDescription}
      metaTitle={props.metaTitle}
      metaUrl={props.metaUrl}
      // TODO: Hidden for now. To be implemented later on
      // additionalContent={<ArticleGrid />}
      header={
        <HomeHeader
          filterBarRef={filterBarRef}
          industries={data?.industries ?? []}
          topics={data?.topics ?? []}
        />
      }
      hero={
        <HomeHero
          filterBarRef={filterBarRef}
          industries={data?.industries ?? []}
          topics={data?.topics ?? []}
        />
      }
      sidebar={
        data ? (
          <Sidebar hidden={props.hideSidebar} industries={data.industries} topics={data.topics} />
        ) : null
      }
    >
      {props.children}
    </Layout>
  );
}

HomeLayout.runDataQueries = (apolloClient: ApolloClient<any>) => {
  return sidebarDataQueries(apolloClient);
};
